import { type Appointment } from "services/types/appointments.type";
import { type Sale } from "services/types/sales.type";
import { formatDateOnlyValue } from "utils/common";

export const getSaleDisplay = (sale: Sale) => {
  const appointmentType = (sale.appointment as Appointment)?.appointmentType
    ?.name;

  return [
    `${sale.id}`,
    sale.service_date
      ? `${formatDateOnlyValue(sale.service_date)}${
          appointmentType ? ` (${appointmentType})` : ""
        }`
      : "Future fitting Appointment"
  ]
    .filter(Boolean)
    .join(" - ");
};
